let state = {
    tops: true,
}

let getters = {

}

let actions = {

}

let mutations = {
    upTops(state, data) {
        state.tops = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}